import { render, staticRenderFns } from "./NoneForm.vue?vue&type=template&id=a3decc5c&scoped=true&"
import script from "./NoneForm.vue?vue&type=script&lang=ts&"
export * from "./NoneForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3decc5c",
  null
  
)

export default component.exports